import React from "react"
import { Dropdown, Button, Table, TableBody, Checkbox } from "semantic-ui-react"
import { withTranslation } from "react-i18next"

const options = [
  // { key: 0, value: 0, text: "0 months" },
  { key: 1, value: 1, text: "1 months" },
  { key: 2, value: 2, text: "2 months" },
  { key: 3, value: 3, text: "3 months" },
  { key: 4, value: 4, text: "4 months" },
  { key: 5, value: 5, text: "5 months" },
  { key: 6, value: 6, text: "6 months" },
  { key: 7, value: 7, text: "7 months" },
  { key: 8, value: 8, text: "8 months" },
  { key: 9, value: 9, text: "9 months" },
  { key: 10, value: 10, text: "10 months" },
  { key: 11, value: 11, text: "11 months" },
  { key: 12, value: 12, text: "12 months" },
]

@withTranslation()
export default class PaymentComponent extends React.Component {
  state = { arr: this.props.toPay, total: 0, del: [] }

  editMonth = (el, v) => {
    let arr = [...this.state.arr]
    const o = parseInt(el["months"])
    let a = false
    el["months"] = v
    let d = el["endDate"].split("-")
    let m = parseInt(d[1]) + v - o
    let y = parseInt(d[0])
    if (m > 12) {
      m -= 12
      y += 1
    }
    if (m < 1) {
      m += 12
      y -= 1
    }
    el["endDate"] = [y, m, d[2]].join("-")
    if (v === 0) {
      arr = arr.filter((q) => q["name"] !== el["name"])
    } else {
      arr = arr.map((q) => {
        if (el["name"] === q["name"]) {
          q = el
        }
        return q
      })
    }
    this.setState({ arr: arr })
  }

  del = () => {
    const arr = this.state.arr.filter(
      (el) => this.state.del.filter((q) => q === el).length === 0,
    )
    this.setState({ arr: arr, del: [] })
    if (arr.length === 0) {
      this.props.closeFunction()
    }
  }

  render() {
    const { t } = this.props
    const arr = [...this.state.arr]
    let total = 0
    return (
      <div>
        <div style={{ overflowX: "scroll" }}>
          <Table celled unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{t("name")}</Table.HeaderCell>
                <Table.HeaderCell>{t("fyscalization")}</Table.HeaderCell>
                <Table.HeaderCell>{t("extendsFor")}</Table.HeaderCell>
                <Table.HeaderCell>{t("duration")}</Table.HeaderCell>
                <Table.HeaderCell>{t("smartkassa")}</Table.HeaderCell>
                <Table.HeaderCell>{t("webkassa")}</Table.HeaderCell>
                <Table.HeaderCell>{t("total")}</Table.HeaderCell>
                <Table.HeaderCell>
                  <p onClick={this.del} style={{ color: "red" }}>
                    {t("delete")}
                  </p>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <TableBody>
              {arr.map((el) => {
                total +=
                  el["months"] * (el["web_kassa_cost"] + el["smartkassa_cost"])
                return (
                  // eslint-disable-next-line react/jsx-key
                  <Table.Row>
                    <Table.Cell>{el["name"]}</Table.Cell>
                    <Table.Cell>
                      {el["fyscalization"]
                        ? t("fyscalized")
                        : t("nonFyscalized")}
                    </Table.Cell>
                    <Table.Cell>
                      <Dropdown
                        placeholder={
                          <p style={{ color: "black" }}>
                            {el["months"] + " " + t("months")}
                          </p>
                        }
                        fluid
                        selection
                        options={options}
                        onChange={(e, d) => {
                          this.editMonth(el, d.value)
                        }}
                        style={{ width: 130 }}
                      />
                      {
                        // el["months"] + " months"
                      }
                      {/* <Dropdown
                        style={{
                          zIndex: 99,
                          overflowY: "auto",
                          overflowX: "none",
                        }}
                      >
                        <Dropdown.Menu>
                          {options.map((e) => {
                            return (
                              <Dropdown.Item
                                onClick={() => this.editMonth(el, e["value"])}
                                key={e["key"]}
                                content={e["text"]}
                                value={e["value"]}
                              />
                            )
                          })}
                        </Dropdown.Menu>
                        </Dropdown> */}
                    </Table.Cell>
                    <Table.Cell>
                      {new Date(el["endDate"]).toLocaleString("kz", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </Table.Cell>
                    <Table.Cell>{el["smartkassa_cost"]}</Table.Cell>
                    <Table.Cell>{el["web_kassa_cost"]}</Table.Cell>
                    <Table.Cell>
                      {el["months"] *
                        (el["web_kassa_cost"] + el["smartkassa_cost"])}
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox
                        checked={
                          this.state.del.filter((q) => q["name"] === el["name"])
                            .length > 0
                        }
                        onClick={(e, d) => {
                          if (d.checked) {
                            let del = this.state.del
                            del.push(el)
                            this.setState({ del: del })
                          } else {
                            const del = this.state.del.filter(
                              (q) => q["name"] !== el["name"],
                            )
                            this.setState({ del: del })
                          }
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                )
              })}
              <Table.Row>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell>
                  <Checkbox
                    label={t("select") + " " + t("all")}
                    checked={this.state.del.length === this.state.arr.length}
                    onClick={() => {
                      const del = [...this.state.arr]
                      this.setState({ del: del })
                    }}
                  />
                </Table.Cell>
              </Table.Row>
            </TableBody>
          </Table>
        </div>
        <p>{t("total") + " : " + total}</p>
        <Button color="green" onClick={this.props.closeFunction}>
          {t("pay")}
        </Button>
      </div>
    )
  }
}
